<span [innerHtml]="product().proprietaryName | textHighlight: queryText()"></span>
@if (product().strength) {
  <span class="detail"> {{ product().strength }}</span>
}
@if (product().dosageForm) {
  <span class="detail"> · {{ product().dosageForm }}</span>
}
<div class="labels">
  @if (product().schedule) {
    <span class="label">{{ product().schedule }}</span>
  }
  @if (product().isDiscontinued) {
    <span class="label">Discontinued</span>
  }
  @if (product().isCloseMatch) {
    <span class="label">Close match</span>
  }
</div>
